 
import CommonApp from '../../app.js'; 

 
CommonApp.module.directive('nsFieldspinner', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            display: '='
        },
        link: function(scope, elem, attrs, ctrl) {
            scope.$watch('display', function() {
                if (scope.display) {
                    elem.addClass('loading-spinner');
                    angular.element(document).find('img#passwordImage').css('display', 'none');
                } else if (scope.display == false) {
                    elem.removeClass('loading-spinner');
                    angular.element(document).find('img#passwordImage').css('display', 'inline-block');
                }
            });
        }
    };
}); 



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/formUtils/formUtils.js
// module id = 270
// module chunks = 0